import Vue from 'vue';
// import { ModalPlugin, DropdownPlugin, IconsPlugin } from 'bootstrap-vue';
import {
  BIcon,
  BIconCheckCircleFill,
  BIconExclamationCircleFill,
  BIconSearch,
} from 'bootstrap-vue';
import VueGtag from 'vue-gtag';
import axios from 'axios';
import pagination from 'laravel-vue-pagination';
import * as Sentry from '@sentry/browser/esm';
import { Vue as VueIntegration } from '@sentry/integrations/esm';
import App from './App.vue';
import router from './router';
import store from './store';
import config from './config';

const { sentryDsn } = config;

Vue.config.productionTip = false;

axios.defaults.baseURL = config.baseApiUrl;
axios.defaults.withCredentials = true;

// Vue.use(ModalPlugin);
// Vue.use(DropdownPlugin);

Vue.component('BIcon', BIcon);
Vue.component('BIconCheckCircleFill', BIconCheckCircleFill);
Vue.component('BIconExclamationCircleFill', BIconExclamationCircleFill);
Vue.component('BIconSearch', BIconSearch);

Vue.component('pagination', pagination);

if (sentryDsn) {
  const vueInstance: any = Vue;

  Sentry.init({
    dsn: sentryDsn,
    integrations: [new VueIntegration({ Vue: vueInstance, attachProps: true, logErrors: true })],
  });
}

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GTAG,
    enabled: !!process.env.VUE_APP_GTAG,
  },
}, router);

new Vue({
  router,
  store,
  created() {
    this.loadUser();

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.$store.dispatch('logout');
          this.$router.push({ name: 'Login' });
        }

        return Promise.reject(error);
      },
    );
  },

  methods: {
    async loadUser() {
      this.$store.commit('setLoadingState', true);

      try {
        await this.$store.dispatch('fetchCsrf');
        await this.$store.dispatch('retrieveUserFromStorage');
        await this.$store.dispatch('fetchUser');
      } catch (err) {
        //
      }

      this.$store.commit('setLoadingState', false);
    },
  },

  render: (h) => h(App),
}).$mount('#app');
